@if (params.context.componentParent.showRowInEditMode(params.node)) {
<mat-select [(ngModel)]="selectedPlant" (ngModelChange)="setPlantColorId()">
  @for (plant of plants; track getIdentifier($index, plant)) {
  <mat-option [value]="plant.id">
    {{ plant.name }}
  </mat-option>
  }
</mat-select>
} @if (params.context.componentParent.showRowInViewMode(params.node)) { @if (!useCellColorFill) {
<mat-icon class="fa fa-circle m-1 pl-1" [ngStyle]="{ color: iconColor }"> </mat-icon>
<span>{{ params.value }}</span>
} @if (useCellColorFill) {
<span>{{ params.value }}</span>
} }
